import { memo } from 'react';
import { GiveawayDetailedArchive } from '@/entities/giveaway/types';
import styles from './DetailedPrizesArchive.module.scss';
import { ReactComponent as FirstPlaceIcon } from '@/assets/Icons/gold.svg';
import { ReactComponent as SecondPlaceIcon } from '@/assets/Icons/silver.svg';
import { ReactComponent as ThirdPlaceIcon } from '@/assets/Icons/bronze.svg';
import { TelegramSticker } from '@/components/TelegramSticker';
import cleanUrl from '@/utils/cleanUrl';
import { useWordDeclension } from '@/utils/wordDeclension';

interface DetailedPrizesArchiveProps {
  giveaway: GiveawayDetailedArchive;
}

const DetailedPrizesArchive = ({ giveaway }: DetailedPrizesArchiveProps) => {
  const sortedWinners = [...giveaway.winners].sort((a, b) => a.place - b.place);

  const getPrize = (place: number) => {
    return giveaway.prizes.find(
      (prize) => place >= prize.start_range && place <= prize.end_range,
    );
  };

  const PrizeItem = memo(({ item_url }: { item_url: string }) => {
    return (
      <TelegramSticker
        tgsUrl={cleanUrl(item_url!)}
        style={{
          width: 40,
          height: 40,
          borderRadius: '8px',
          overflow: 'hidden',
        }}
        loop={true}
        autoplay={true}
      />
    );
  });

  return (
    <div className={styles.prizeList}>
      {sortedWinners.map((winner, index) => {
        const prize = getPrize(winner.place);
        return (
          <div className={styles.prizeItem} key={index}>
            <div className={styles.prizeItemPlace}>
              {winner.place === 1 && <FirstPlaceIcon />}
              {winner.place === 2 && <SecondPlaceIcon />}
              {winner.place === 3 && <ThirdPlaceIcon />}
              {winner.place > 3 && winner.place}
            </div>
            <div className={styles.prizeWinner}>
              <img
                src={winner.photo_url}
                className={styles.winnerPhoto}
                alt="winner"
              />
              <div className={styles.prizeWinnerName}>{winner.name}</div>
            </div>
            <div className={styles.prize}>
              {prize?.currency_type === 'nfts' ? (
                <>
                  <div className={styles.mainPrizeItemNameContainer}>
                    <div className={styles.mainPrizeItemName}>
                      {prize?.name}
                    </div>
                    <div className={styles.mainPrizeItemCode}>
                      #{prize?.serial_number}
                    </div>
                  </div>
                  <div
                    onClick={() => {
                      if (
                        prize?.currency_type === 'nfts' &&
                        prize.details_url
                      ) {
                        window?.Telegram?.WebApp?.openTelegramLink(
                          prize.details_url,
                        );
                      }
                    }}
                    className={styles.prizeItem}
                  >
                    {prize && <PrizeItem item_url={prize.image_url_with_bg} />}
                  </div>
                </>
              ) : (
                <>
                  <div className={styles.prizeItemNameContainer}>
                    <div className={styles.prizeItemQuantity}>
                      {prize?.quantity}
                    </div>
                    <div className={styles.prizeItemCurrencyStatic}>
                      {prize?.currency_type === 'stars'
                        ? useWordDeclension(prize.quantity, {
                            one: 'звезда',
                            few: 'звезды',
                            many: 'звезд',
                          })
                        : prize?.currency_type}
                    </div>
                  </div>
                  <div className={styles.prizeItemStatic}>
                    {prize && (
                      <img
                        src={prize.image_url_with_bg}
                        className={styles.prizeItemImage}
                        alt="prize"
                      />
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default DetailedPrizesArchive;
